<template>
  <Card class="h-full">
    <template #title>
      <div class="text-xl">Geolocation Restriction</div>
    </template>
    <template #content>
      <div class="grid">
        <div class="flex flex-column gap-1 col-12">
          <label for="geo_bl">Geolocation Blacklist</label>
          <MultiSelect
            inputId="geo_bl"
            :modelValue="geoBl"
            @update:modelValue="$emit('update:geoBl', $event)"
            :options="countryList"
            optionLabel="name.common"
            optionValue="cca2"
            placeholder="Select Countries"
            display="chip"
            filter
            class="w-full"
          />
        </div>
        <div class="flex flex-column gap-1 col-12">
          <label for="geo_wl">Geolocation Whitelist</label>
          <MultiSelect
            inputId="geo_wl"
            :modelValue="geoWl"
            @update:modelValue="$emit('update:geoWl', $event)"
            :options="countryList"
            optionLabel="name.common"
            optionValue="cca2"
            placeholder="Select Countries"
            display="chip"
            filter
            class="w-full"
          />
        </div>
      </div>
    </template>
  </Card>
</template>

<script setup>
import Card from "primevue/card";
import MultiSelect from "primevue/multiselect";

defineProps({
  geoBl: {
    type: Array,
    default: () => [],
  },
  geoWl: {
    type: Array,
    default: () => [],
  },
  countryList: {
    type: Array,
    default: () => [],
  },
});
defineEmits(["update:geoBl", "update:geoWl"]);
</script>
